import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "../style/Shortener.scss";
import ShortenedItem from "./ShortenedItem";

function Shortener() {
  const {
    register,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
  } = useForm();

  const [links, setLinks] = useState(
    JSON.parse(localStorage.getItem("links"))
      ? JSON.parse(localStorage.getItem("links"))
      : []
  );

  const onSubmit = (data) => {
    axios
      .get("https://api.shrtco.de/v2/shorten", {
        params: {
          url: data.url,
        },
      })
      .then((res) => {
        setLinks((oldLinks) => {
          return [
            {
              id: Date.now(),
              original: res.data.result.original_link,
              short: res.data.result.full_short_link,
            },
            ...oldLinks,
          ];
        });
      })
      .catch(() => {
        setError(
          "url",
          { type: "bad url", message: "This url is not valid!" },
          { shouldFocus: true }
        );
      });

    //clear input after every submit
    setValue("url", "");
  };

  const deleteLink = (id) => {
    setLinks((oldLinks) => {
      return oldLinks.filter((link) => link.id !== id);
    });
    console.log("ahoj");
  };

  useEffect(() => {
    localStorage.setItem("links", JSON.stringify(links));
  }, [links]);

  return (
    <div className="shortener" id="shortener">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input-container">
          <input
            type="text"
            className={`${errors.url ? "error" : ""}`}
            placeholder="Shorten a link here..."
            {...register("url", { required: "Please add a link" })}
          />
          {errors.url && <p className="error-message">{errors.url.message}</p>}
        </div>
        <button type="submit" className="btn">
          Shorten it!
        </button>
      </form>

      {links.map((link) => {
        const { id } = link;
        return <ShortenedItem key={id} {...link} deleteLink={deleteLink} />;
      })}
    </div>
  );
}

export default Shortener;
